<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Orders</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Orders
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <div class="row grouped-multiple-statistics-card">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-lg-6 col-xl-3 col-sm-6 col-12 mb-4">
                                    <div
                                        class="d-flex align-items-start mb-sm-1 mb-xl-0 border-right-blue-grey border-right-lighten-5">
                                        <span class="card-icon primary d-flex justify-content-center mr-3">
                                            <i class="icon p-1 icon-bar-chart customize-icon font-large-2 p-1"></i>
                                        </span>
                                        <div class="stats-amount mr-4">
                                            <h3 class="heading-text text-bold-600">
                                                {{ fulfillment_analytics.no_of_orders }}
                                            </h3>
                                            <p class="sub-heading" style="margin-right: 5%;">No of Orders </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-6 col-xl-3 col-sm-6 col-12 mb-4">
                                    <div
                                        class="d-flex align-items-start mb-sm-1 mb-xl-0 border-right-blue-grey border-right-lighten-5">
                                        <span class="card-icon danger d-flex justify-content-center mr-2">
                                            <i class="icon p-1 icon-users customize-icon font-large-2 p-1"></i>
                                        </span>
                                        <div class="stats-amount mr-5">
                                            <h3 class="heading-text text-bold-600">
                                                {{ fulfillment_analytics.fulfilled_orders }}
                                            </h3>
                                            <p class="sub-heading"> Fulfilled Orders </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-6 col-xl-3 col-sm-6 col-12 mb-4">
                                    <div class="d-flex align-items-start border-right-blue-grey border-right-lighten-5">
                                        <span class="card-icon success d-flex justify-content-center mr-3">
                                            <i class="fa p-1 fa-building customize-icon font-large-2 p-1"></i>
                                        </span>
                                        <div class="stats-amount mr-3">
                                            <h3 class="heading-text text-bold-600">
                                                {{ fulfillment_analytics.pending_orders }}
                                            </h3>
                                            <p class="sub-heading"> Pending Orders </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-6 col-xl-3 col-sm-6 col-12 mb-4">
                                    <div class="d-flex align-items-start">
                                        <span class="card-icon warning d-flex justify-content-center mr-3">
                                            <i class="icon p-1 icon-basket-loaded customize-icon font-large-2 p-1"></i>
                                        </span>
                                        <div class="stats-amount mr-3">
                                            <h3 class="heading-text text-bold-600">
                                                {{ fulfillment_analytics.percentage_orders_fulfilled_early }}
                                            </h3>
                                            <p class="sub-heading">% Fulfilled Early Orders</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-6 col-xl-3 col-sm-6 col-12">
                                    <div class="d-flex align-items-start">
                                        <span class="card-icon warning d-flex justify-content-center mr-3">
                                            <i class="icon p-1 icon-basket-loaded customize-icon font-large-2 p-1"></i>
                                        </span>
                                        <div class="stats-amount mr-3">
                                            <h3 class="heading-text text-bold-600">
                                                {{ fulfillment_analytics.percentage_orders_fulfilled_late }}
                                            </h3>
                                            <p class="sub-heading">% Fulfilled Late Orders</p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section class="card">
                <div class="card-header">
                    <h4>Orders</h4>
                    <div class="col-lg-3 col-md-4 col-sm-6 d-flex">
                        <download-excel
                            ref="exporter-csv"
                            v-show="false"
                            type="csv"
                            :data="exportRows"
                            :export-fields="exportFields"
                            :name="generateReportName('Fulfillment_Report', '.csv')"
                        />
                        <download-excel
                            ref="exporter-xls"
                            v-show="false"
                            type="xls"
                            :data="exportRows"
                            :export-fields="exportFields"
                            :name="generateReportName('Fulfillment_Report', '.xls')"
                        />
                        <a href="#" @click.prevent="exportTableData('admin.fulfillment.index', {}, 'csv')" class="export-link">
                            <i class="fas fa-file-csv"></i> Export to CSV</a> | &nbsp;
                        <a href="#" @click.prevent="exportTableData('admin.fulfillment.index', {}, 'xls')" class="export-link text-warning">
                            <i class="fa fa-file-excel-o"></i> Export to Excel</a>
                    </div>
                </div>

                <div class="card-body">
                    <form>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="category">By State</label>
                                    <select name="store" class="form-control form-control-sm"
                                            v-model="filters.state">
                                        <option :value="null" :selected="filters.state==null">All</option>
                                        <option v-for="state in states" :key="state.id"
                                                :value="state.id">
                                            {{ state.name }}
                                        </option>
                                    </select>
                                    <template v-if="errors.state">
                                        <small class="text-danger" v-for="error in errors.state">
                                            {{ error }}
                                        </small>
                                        <br>
                                    </template>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="category">By Store</label>
                                    <select name="store" class="form-control form-control-sm"
                                            v-model="filters.store">
                                        <option :value="null" :selected="filters.store==null">All</option>
                                        <option v-for="store in stores" :key="store.id"
                                                :value="store.id">
                                            {{ store.name }}
                                        </option>
                                    </select>
                                    <template v-if="errors.store">
                                        <small class="text-danger" v-for="error in errors.store">
                                            {{ error }}
                                        </small>
                                        <br>
                                    </template>
                                </div>
                            </div>
                            <div class="col-md-4">
<!--                                <div class="form-group">-->
<!--                                    <label for="category">By Fulfillment Status</label>-->
<!--                                    <select name="category" id="category" class="form-control form-control-sm"-->
<!--                                            v-model="filters.status">-->
<!--                                        <option :value="null" :selected="filters.status==null">All</option>-->
<!--                                        <option v-for="status in statuses" :key="status"-->
<!--                                                :value="status">-->
<!--                                            {{ status }}-->
<!--                                        </option>-->
<!--                                    </select>-->
<!--                                    <template v-if="errors.status">-->
<!--                                        <small class="text-danger" v-for="error in errors.status">-->
<!--                                            {{ error }}-->
<!--                                        </small>-->
<!--                                        <br>-->
<!--                                    </template>-->
<!--                                </div>-->
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="category">By Start Date</label>
                                    <date-time-field name="category" id="category" class="form-control form-control-sm" v-model="filters.start_date" bound="start"></date-time-field>
                                    <template v-if="errors.start_date">
                                        <small class="text-danger" v-for="error in errors.start_date">
                                            {{ error }}
                                        </small>
                                        <br>
                                    </template>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-12 col-xs-12">
                                <div class="form-group">
                                    <label for="category">By End Date</label>
                                    <date-time-field name="category" id="category" class="form-control form-control-sm" v-model="filters.end_date" bound="end"></date-time-field>
                                    <template v-if="errors.end_date">
                                        <small class="text-danger" v-for="error in errors.end_date">
                                            {{ error }}
                                        </small>
                                        <br>
                                    </template>
                                </div>
                            </div>
                            <div class="col-md-12 mb-2">
                                <label>&nbsp;</label>
                                <br>
                                <button type="submit" @click.prevent="paginatedData"
                                        class="btn btn-primary glow mb-1 mb-sm-0">Apply Filter
                                </button>
                                <button type="reset" @click.prevent="resetFilters"
                                        class="btn btn-warning glow mb-1 mb-sm-0">
                                    Reset Filter
                                </button>
                            </div>
                        </div>
                    </form>
                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        :sort-options="sortingOptions"
                        @on-page-change="this.onPageChange"
                        @on-per-page-change="this.onPerPageChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allOrders"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                            <table-row-actions v-else-if="props.column.field === 'action'">
                                <a :href="route('admin.orders.show', props.row.id)" class="dropdown-item">
                                    <i class="feather icon-eye"></i>
                                    View
                                </a>
                                <a href="#" @click.prevent="showAlert(props.row.id)" class="dropdown-item text-danger">
                                    <i class="feather icon-trash-2"></i>
                                    Delete
                                </a>
                            </table-row-actions>
                            <span v-else-if="props.column.field === 'excel_order_status'" class="d-flex flex-column">
                                <span class="badge badge-glow" :style="{ backgroundColor: props.row.badge_color }">
                                    {{
                                        props.row.excel_order_status
                                    }}
                                </span>
                            </span>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2'
import DeleteAlert from "../../Shared/Mixins/DeleteAlert";
import PaginationMixin from "../../Shared/Mixins/PaginationMixin";
import TableExportMixin from "../../Shared/Mixins/TableExportMixin";
import {color} from "chart.js/helpers";

export default {
    metaInfo: {title: 'Fulfillment Dashboard'},
    props: [
        'orders',
        'stores',
        'payment_channels',
        'statuses',
        'payment_statuses',
        'userId',
        'states',
        'fulfillment_analytics'
    ],
    layout: Layout,
    name: 'FulfillmentIndex',
    components: {
        Link,
        DeleteAlert,
    },
    mixins: [
        PaginationMixin,
        TableExportMixin,
    ],
    data() {
        return {
            status: [
                'Fulfilled',
                'Pending'
            ],
            errors: {},
            saving: false,
            filters: {
                state: null,
                status: null,
                store: null,
                start_date: null,
                end_date: this.getCurrentDate(),
            },
            isLoadingFilter: false,
            allOrders: [],
            exportRows: [],
            refundCustomer: this.$inertia.form({
                order_id: null,
                amount: null,
            }),
            totalRecords: 0,
            serverParams: {
                page: 1,
                perPage: 10,
                columnFilters: {},
            },

            paginationOptions: {
                enabled: true,
                mode: 'pages',
                perPage: 10,
                perPageDropdown: [5, 10, 20, 50, 100, 200],
                dropdownAllowAll: false,
            },

            sortingOptions: {
                enabled: false,
            },
            columns: [
                {label: 'S/N', field: 'sn', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Order Number', field: 'order_number', thClass: 'text-center', tdClass: 'text-center'},
                {
                    label: 'Store', field: 'store',
                    thClass: 'text-center', tdClass: 'text-center',
                },
                {
                    label: 'State', field: 'state',
                    thClass: 'text-center', tdClass: 'text-center',
                },
                {
                    label: 'Assignment Period', field: 'assignment_period',
                    thClass: 'text-center', tdClass: 'text-center', color: 'assignment_period_color'
                },
                {
                    label: 'Order Start Period', field: 'order_pickup_period', color: 'order_pickup_period_color',
                    thClass: 'text-center', tdClass: 'text-center',
                },
                {
                    label: 'Rider Completion Period', field: 'rider_completion_period',
                    thClass: 'text-center', tdClass: 'text-center', color: 'rider_completion_period_color'
                },
                {
                    label: 'Rider Name', field: 'rider_name',
                    thClass: 'text-center', tdClass: 'text-center', color: 'rider_name'
                },
                {
                    label: 'Rider Plate Number', field: 'rider_plate_number',
                    thClass: 'text-center', tdClass: 'text-center', color: 'rider_plate_number'
                },
                {
                    label: 'Order Fulfillment Period', field: 'total_completion_period',
                    thClass: 'text-center', tdClass: 'text-center', color:'total_completion_period_color'
                },
                {
                    label: 'Status', field: 'excel_order_status',
                    thClass: 'text-center', tdClass: 'text-center',
                },
                {label: 'Action', field: 'action', sortable: false},
            ],
            tableDataLoading: false,
        }
    },
    computed: {
        exportFields() {
            return {
                'Order number': 'order_number',
                'Store': 'store',
                'State': 'state',
                'Order Time': 'order_time',
                'Assignment Time': 'assigned_time',
                'Rider Start Time': 'rider_start_time',
                'Rider Completion Time': 'rider_completion_time',
                'Assignment period': 'assignment_period',
                'Order Start Period': 'order_pickup_period',
                'Rider completion period': 'rider_completion_period',
                'Rider Name': 'rider_name',
                'Rider Plate Number': 'ride_plate_number',
                'Order Fulfillment period': 'total_completion_period',
                'Shipping Address': 'shipping_address',
                'Status': 'excel_order_status',
            };
        },
    },
    mounted() {
        this.allOrders = this.orders.data ?? [];
        this.totalRecords = this.orders.meta.total ?? 0;
    },

    methods: {
        generateReportName(name, fileType) {
            let now = new Date();
            let formatted = now.getFullYear() + '-' +
                String(now.getMonth() + 1).padStart(2, '0') + '-' +
                String(now.getDate()).padStart(2, '0') + '_' +
                String(now.getHours()).padStart(2, '0') + '-' +
                String(now.getMinutes()).padStart(2, '0') + '-' +
                String(now.getSeconds()).padStart(2, '0');

            return `${name}_${formatted}${fileType}`;
        },
        color,
        getCurrentDate() {
            const local = new Date();
            local.setMinutes(local.getMinutes() - local.getTimezoneOffset());
            return local.toJSON().slice(0, 10);
        },
        async paginatedData() {
            try {

                let routeName = route('admin.fulfillment.index');
                this.errors = {};
                let response = await axios.get(routeName, {
                    params: {
                        page: this.serverParams.page,
                        per_page: this.serverParams.perPage,
                        api: true,
                        ...this.filters
                    },
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                    },
                });

                this.totalRecords = response.data.meta.total;
                this.paginationOptions.perPage = response.data.meta.per_page;
                this.serverParams.perPage = response.data.meta.per_page;
                this.paginationOptions.setCurrentPage = response.data.meta.page;
                this.allOrders = response.data.data
            } catch (error) {
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                } else {
                    console.log(error);
                }
            }
        },
        async resetFilters() {
            for (let filter in this.filters) {
                this.filters[filter] = null;
            }
            await this.paginatedData();
        },
        async showAlert(orderId) {
            const details = {
                title: "Are you sure you want to delete this order?",
                text: "You won't be able to revert this!",
            }
            await this.deleteAlert(details.title, details.text) ? await this.deleteOrder(orderId) : "";
        },
        async deleteOrder(id) {
            this.$inertia.delete(route('admin.orders.delete', id), {
                preserveScroll: true,
                onSuccess: () => {
                    this.paginatedData();
                }
            })
        },
    }
}
</script>
